import React, { useState, useEffect } from 'react';
import Doughnutchart from './Doughnutchart';
import ClipLoader from 'react-spinners/ClipLoader';

function Top10Airplanes({setloading8, year}){
  
  const [airplanesData, setairplanesData] = useState(null);
  const [airplanesOptions, setairplanesOptions] = useState({});


  const [excelDataChart4,setexcelDataChart4] = useState([]);


  useEffect(() => {
   var url = "api/groupby_aircraft_type/" + year;
   fetch(url).then((res) =>
     res.json().then((res) => {
      
      setexcelDataChart4(res.data.aircraftbytype);
      
       let listOfValues = res.data.aircraftbytype.map((aircraft, i) => {
         return res.data.aircraftbytype[i].count;
       });

       let IndexList = listOfValues.map((value, index) => ({ value, index }))
       .sort((a, b) => b.value - a.value).slice(0, 10).map(obj => obj.index);

       let listOfIds = []
       let values = []
       IndexList.map((n) =>{
           listOfIds.push(res.data.aircraftbytype[n]["Τύπος Α/φους"])
           values.push(res.data.aircraftbytype[n].count)
           return(0)
       } );
       


       setairplanesData({
         labels: listOfIds,
         datasets: [{
           label: "",
           data: values,
           backgroundColor: [
             '#45474D',
             '#EFB7FF',
             'black',
             '#8D939C',
             'aqua',
             '#012D81',
             '#75D1D8',
             '#A471D1',
             '#FEAB7A',
             '#FF9B91',
           ],
           borderColor: "black",
           borderWidth: 0.1,
         }]
       })
   
       setairplanesOptions({
         maintainAspectRatio: false,
         responsive: true,
         plugins: {
           legend: {
             position: 'right',
           },
         }
   
       })
   
      setloading8(false)


     })
   )
   .catch((error) => {
     console.log("Refetching data for table4!")
   })

 }, [year, setloading8]);



    return(
        airplanesData? <Doughnutchart chartData={airplanesData} chartOptions ={airplanesOptions} excelData = {excelDataChart4} ></Doughnutchart>:
        <ClipLoader size={100} color={'#123abc'} loading={true}/>
       
    )
}




export default Top10Airplanes;